import React from 'react';
import styled from 'styled-components';
import amc from "../../../assets/images/solutions/amc.png"

const PLMSolutionsAMCOverview = () => {
  return (
    <AboutSectionWrapper>
      <Container className='container'>
        <Row>
          {/* Content Column */}
          <ContentColumn>
            <InnerColumn>
              <SecTitle>
                <Title>About Us</Title>
                <Heading>Overview</Heading>
              </SecTitle>
              <Text>
              Nextech recognizes that even with the best PLM system like Teamcenter, organizations may struggle to realize the tangible benefits of PLM systems. This is often due to factors such as incorrect configuration, insufficient knowledge on administration, maintenance, and performance, as well as a lack of timely access to qualified technical resources to address technological challenges.   
              </Text>
              <Text>
              Teamcenter PLM Site Solutions AMC is addressing the above challenges efficiently and effectively to ensure the PLM system achieves the organizational business goal with high reliability, availability, usage, and performance of the Teamcenter PLM system. 
              Teamcenter PLM site AMC contract between NexTech & Customer includes Solutions Development along with Administration and Maintenance of the System.  This ensures Teamcenter Solution’s high availability, reliability, performance, and increasing usage of the PLM system. 
              </Text>
            
            </InnerColumn>
          </ContentColumn>
          {/* Image Column */}
          <ImageColumn>
            <ImageInnerColumn data-wow-delay="0ms" data-wow-duration="1500ms">
              <ImageWrapper>
                <Image src={amc} alt="teamcenter solutions amc" />
                <ImageOverlayBox></ImageOverlayBox>
              </ImageWrapper>
            </ImageInnerColumn>
          </ImageColumn>
        </Row>
      </Container>
    </AboutSectionWrapper>
  );
};

export default PLMSolutionsAMCOverview;



const AboutSectionWrapper = styled.section`
  font-family: "Poppins", system-ui;
  position: relative;
  padding: 20px 0px;
`;

const Container = styled.div`
  .container;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column; 
  }

`;

const ContentColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 10px;
  @media (max-width: 992px) {
    padding-right: 0;
  }
`;

const InnerColumn = styled.div`
  position: relative;
  padding-top: 50px;

`;

const SecTitle = styled.div`
  position: relative;
  padding-bottom: 40px;
`;

const Title = styled.div`
  position: relative;
  color: #d7a449;
  font-size: 18px;
  font-weight: 700;
  padding-right: 50px;
  margin-bottom: 15px;
  display: inline-block;
  text-transform: capitalize;

  &:before {
    position: absolute;
    content: '';
    right: 0px;
    bottom: 7px;
    width: 40px;
    height: 1px;
    background-color: #bbbbbb;
  }
`;

const Heading = styled.h2`
  color: #252525;
`;

const Text = styled.div`
  position: relative;
  color: #777777;
 font-size: 1em;
  line-height: 2em;
  margin-bottom: 40px;
  text-align: justify;  
`;

const ImageColumn = styled.div`
  flex: 1;
  position: relative;
  margin-bottom: 50px;
`;

const ImageInnerColumn = styled.div`
  position: relative;
  padding: 40px 40px 0px 0px;
  margin-left: 50px;

  &:after {
        position: absolute;
    content: '';
    right: 27px;
    top: 5px;
    left: 40px;
    bottom: 64px;
    z-index: -1;
    border: 2px solid #d7a449;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
`;

const ImageOverlayBox = styled.div`
  position: absolute;
  left: 40px;
  bottom: 48px;
`;

const Image = styled.img`
  position: relative;
  width: 90%; /* Adjust the width as needed */
  display: block;
  margin: 0 auto; /* Center the image */
`;